module.exports = __webpack_public_path__ + "img/hc_main_new.f671fac4.png";